export default __webpack_public_path__ + "static/media/about_johnhubbard_desc.76a91398.png";